module.exports = __webpack_public_path__ + "static/media/pic_shuijing.bf80c6a1.png";